import { validateEnum } from "../core/Helpers";
export var GooglePayTotalPriceStatusObj = {
    NOT_CURRENTLY_KNOWN: "NOT_CURRENTLY_KNOWN",
    ESTIMATED: "ESTIMATED",
    FINAL: "FINAL",
};
export var validateGooglePayTotalPriceStatus = function (googlePayTotalPriceStatus) {
    return validateEnum(googlePayTotalPriceStatus, GooglePayTotalPriceStatusObj);
};
